import { DASHBOARD_INITIAL_MORTGAGE_INPUT_MODAL } from '@interhyp/api-dashboard';
import { modalExtension } from '@interhyp/platform-modal';
import { createModule } from '@interhyp/platform-module';
import { lazy } from 'react';

export default createModule({
  name: 'portal-interim-home-initial-data-input',
  extensions: [
    modalExtension.createExtension({
      id: DASHBOARD_INITIAL_MORTGAGE_INPUT_MODAL,
      modal: lazy(() => import('./InitialDataInputModal')),
    }),
  ],
});
